module.exports = __webpack_public_path__ + "static/img/mobile-3.f153588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-3.png
// module id = 75
// module chunks = 2